import { SummaryStatsCard } from '@exam-center/components';
import { Flex } from '@shared/components';

export interface RecurringExamEventSummarySectionProps {
  summary: {
    totalEvents: number;
    creatableEvents: number;
    nonCreatableEvents: number;
  };
}

export default function RecurringExamEventSummarySection(
  props: Readonly<RecurringExamEventSummarySectionProps>,
) {
  const { summary } = props;
  return (
    <Flex
      sx={{
        gap: (theme) => theme.spacing(4),
      }}
    >
      <SummaryStatsCard title='จำนวนรอบสอบทั้งหมด' displayValue={`${summary.totalEvents}`} />
      <SummaryStatsCard
        title='รอบสอบที่สร้างได้'
        color='success'
        displayValue={`${summary.creatableEvents}`}
      />
      <SummaryStatsCard
        title='รอบสอบที่สร้างไม่ได้'
        color='error'
        displayValue={`${summary.nonCreatableEvents}`}
      />
    </Flex>
  );
}
